import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { TextInput } from '../../lib/ui/TextInput';
import { MAX_USER_COMMENT_LENGTH, type QuestionModel } from '../logic';
import { TextModel } from './AnswersView';

export const UserComment: FC<{ questionModel: QuestionModel; className?: string | null }> = observer(({ questionModel, className }) => {
  const { question, userComment, disabled, validationErrors } = questionModel;

  if (questionModel instanceof TextModel || !question.is_comment) {
    return null;
  }

  return (
    <TextInput
      value={userComment}
      onChange={(str) => questionModel.set_userComment(str)}
      placeholder={question.comment_hint}
      disabled={disabled}
      hasWarning={validationErrors.emptyUserCommentError}
      maxLength={MAX_USER_COMMENT_LENGTH}
      className={className}
    />
  );
});
